/** Typed DOM lookups (mini-app assumes ids exist when using must*). */

/** Owner list screens — shared loading placeholder. */
export const OWNER_LIST_LOADING_HTML =
  '<div class="list-loading"><div class="list-loading-spinner"></div><span>Загрузка...</span></div>';

export function getEl<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

export function mustEl<T extends HTMLElement = HTMLElement>(id: string): T {
  return document.getElementById(id) as T;
}

export function getInput(id: string): HTMLInputElement | null {
  return document.getElementById(id) as HTMLInputElement | null;
}

export function mustInput(id: string): HTMLInputElement {
  return document.getElementById(id) as HTMLInputElement;
}

export function getTextArea(id: string): HTMLTextAreaElement | null {
  return document.getElementById(id) as HTMLTextAreaElement | null;
}

export function mustTextArea(id: string): HTMLTextAreaElement {
  return document.getElementById(id) as HTMLTextAreaElement;
}

export function getSelect(id: string): HTMLSelectElement | null {
  return document.getElementById(id) as HTMLSelectElement | null;
}

export function mustSelect(id: string): HTMLSelectElement {
  return document.getElementById(id) as HTMLSelectElement;
}

export function isElement(target: EventTarget | null): target is Element {
  return target instanceof Element;
}

export function closestEl(target: EventTarget | null, selector: string): Element | null {
  return isElement(target) ? target.closest(selector) : null;
}
